<div class="multiagenda-day-container">
  <!-- Header con filtros -->
  <header class="day-header">
    <div class="day-navigation">
      <button class="nav-btn" (click)="previousDay()" [disabled]="!canGoPreviousDay()">
        <app-icon icon="chevron-left" size="2rem" color="--primary" />
      </button>
      <h2 class="day-title">{{ selectedDayTitle() }}</h2>
      <button class="nav-btn" (click)="nextDay()">
        <app-icon icon="chevron-right" size="2rem" color="--primary" />
      </button>
    </div>

    <div class="day-filters">
      <div class="filter-group">
        <label class="filter-label">Día</label>
        <app-select [items]="dayOptions()" [value]="currentDay()"
          (keyString)="onDayChange($event)" inputWidth="80px" />
      </div>

      <div class="filter-group">
        <label class="filter-label">Mes</label>
        <app-select [items]="monthOptions()" [value]="currentMonth()"
          (keyString)="onMonthChange($event)" inputWidth="140px" />
      </div>

      <div class="filter-group">
        <label class="filter-label">Año</label>
        <app-select [items]="yearOptions()" [value]="currentYear()"
          (keyString)="onYearChange($event)" inputWidth="100px" />
      </div>

      <button class="today-btn" (click)="goToToday()">
        Hoy
      </button>
    </div>
  </header>

  <!-- Loading -->
  @if (loadingSeguimientos()) {
  <div class="loading-container">
    <app-load-animation size="40" />
    <span>Cargando seguimientos...</span>
  </div>
  }

  <!-- Vista de día -->
  <div class="day-view">
    <div class="day-view-grid">
      @for (hour of dayHours; track hour) {
      <!-- Hora completa -->
      <div class="day-hour-row">
        <div class="day-time-cell">
          <span class="hour-label">{{ formatHour(hour) }}</span>
        </div>
        <div class="day-activities-cell">
          @for (seg of getSeguimientosForHour(hour); track seg.IdSeguimiento) {
          <div class="day-activity-card" [class.pending]="seg.EstaCumplida === 'No'"
            [class.completed]="seg.EstaCumplida === 'Si'"
            [title]="seg.Prospecto + ' - ' + seg.TipoActividadDetalle + ' (' + seg.Ejecutivo + ')'">
            <div class="day-activity-content">
              <span class="day-activity-name">{{ seg.Prospecto }}</span>
              <span class="day-activity-type">{{ seg.TipoActividadDetalle }}</span>
              <span class="day-activity-time">{{ formatSeguimientoHora(seg) }}</span>
            </div>
            <div class="day-activity-right">
              <span class="day-activity-ejecutivo">{{ seg.Ejecutivo }}</span>
              @if (seg.EstaCumplida === 'Si') {
              <span class="day-activity-badge tarea">CUMPLIDA</span>
              } @else {
              <span class="day-activity-badge pending">PENDIENTE</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      <!-- Media hora -->
      <div class="day-hour-row half">
        <div class="day-time-cell">
          <span class="hour-label half">{{ formatHourHalf(hour) }}</span>
        </div>
        <div class="day-activities-cell"></div>
      </div>
      }
    </div>
  </div>
</div>
